<p-confirmDialog header="Confirmation" width="425"></p-confirmDialog>
<div class="content-block">
  <article class="article " style="margin-top:1rem">
    <div class="back-container">
      <button class="btn btn-back" (click)="back()"><i class="fas fa-caret-left"></i> Back</button>

    </div>
    <hr />
    <div class="form-container">
      <div class="form-column shadow">
        <h3>{{companyName}} Site Details</h3>
        <div style="width: 100%;">
       <app-company-mange [user]="user"  [hideSaveOption]="readOnly" [hideSaveOption]="false" [saveTrigger]="companySaveTrigger" (added)="companySave($event)"
          [selectedCompany]="company"></app-company-mange>

        </div>
 

        <div class="back-container" style="margin-top: 2vh;" *ngIf="!readOnly">
          <button class="btn btn-primary" (click)="triggerCompanySave()">Save</button>
        </div>

      </div>
      <div class="form-column" style="border:none">
        <div class="form-column shadow">
          <h3>View and Edit Equipment List</h3>
          <p>The equipment list can be sorted and filtered through interaction with the equipment list table.</p>
          <button class="btn btn-primary" (click)="viewEquipment()">View</button>
        </div>
        <div class="form-column topMargin shadow" *ngIf="!readOnly">
          <h3>Input Inspection Details</h3>
          <p>Choose the type of report, location required, and sort criteria.</p>

          <div class="btn-container">
            <button class="btn btn-primary" (click)="inputInspection()">Input</button>
          </div>

        </div>
        
        <div class="form-column topMargin shadow" *ngIf="!readOnly">
          <h3>Upload Equipment</h3>
          <p>Upload a excel sheet of equipments to the portal.</p>

          <div class="btn-container">
            <button class="btn btn-primary" (click)="uploadEquipment()">Upload</button>
          </div>

        </div>
        <div class="form-column topMargin shadow" *ngIf="!readOnly">
          <h3>View and Edit Location List</h3>
          <p>The location list can be sorted and filtered through interaction with the location list table.</p>

          <div class="btn-container">
            <button class="btn btn-primary" (click)="viewLocation()">View</button>

          </div>

        </div>
        <div class="form-column topMargin shadow">
          <h3>Customer Home Page Message</h3>
          <label>Message Title (appears bold on first line)</label>
          <input type="text" [(ngModel)]="messageTitle" [attr.disabled]="readOnly ? '' : null"/>
          <label>Message Body</label>
          <textarea wrap="soft" type="text" [attr.disabled]="readOnly ? '' : null"
           style="resize:vertical;width:100%;margin-bottom: 0.5rem;white-space: pre-wrap;"
           rows="5" name="messageBody" [innerHTML]="messageBody" [(ngModel)]="messageBody"></textarea>

           <button class="btn btn-primary" (click)="saveMessage()" *ngIf="!readOnly">Save</button>
        </div>
      </div>

    </div>
  </article>

</div>